import { createContext } from "react";
import { Company, CurrentUser } from "src/api/client-api/useUserNew";

export type UserInitialValues = {
    user: CurrentUser;
    selectedCompany: Company | null;
};
export const UserContext = createContext<UserInitialValues | null>(null);
